// © Microsoft Corporation. All rights reserved.

/**
 * An enumeration of global / fixed connector namespaces
 * Only name spaces that are constant (i.e. not instanced) for the entire SPA lifetime should be listed here
 * NOTE: Keep this list alphabetical
 */
export enum ConnectorNamespaces {
    AdsManager = "AdsManager",
    BingImageData = "BingImageData",
    CategoryData = "CategoryData",
    ChromiumPageSettings = "ChromiumPageSettings",
    CoachmarkData = "CoachmarkData",
    DisplayAdsManager = "DisplayAdsManager",
    ExperienceTrackerData = "ExperienceTrackerData",
    ExperienceTrackerEdgeData = "ExperienceTrackerEdgeData",
    ExperienceTrackerEdgeNextData = "ExperienceTrackerEdgeNextData",
    ExperienceTrackerFirstPartyData = "ExperienceTrackerFirstPartyData",
    ExperienceTrackerMicrosoftNewsData = "ExperienceTrackerMicrosoftNewsData",
    ExperienceTrackerHubData = "ExperienceTrackerHubData",
    ExperienceTrackerOfficeData = "ExperienceOfficeData",
    ExperienceTrackerViewsData = "ExperienceTrackerViewsData",
    FeedbackData = "FeedbackData",
    IrisData = "IrisData",
    LayoutPreferenceData = "LayoutPreferenceData",
    MsccCookieBannerData = "MsccCookieBannerData",
    MilestoneData = "MilestoneData",
    MsNewsPageSettings = "MsNewsPageSettings",
    NavigationData = "NavigationData",
    OfficeSharedData = "OfficeSharedData",
    OneServiceContent = "OneServiceContent",
    PageClickTrackerData = "PageClickTrackerData",
    PageSettingsData = "EdgePageSettings",
    PageLayout = "PageLayout",
    PlacementManager = "PlacementManager",
    PoweredByData = "PoweredByData",
    Preload = "Preload",
    SharedState = "SharedState",
    Telemetry = "TelemetryData",
    TelemetryEdgeChromium = "TelemetryDataEdgeChromium",
    TopicData = "TopicData",
    VerticalPropertyData = "VerticalPropertyData",
    VideoDataManager = "VideoDataManager",
    WeatherData = "WeatherData"
}